import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

const GridBox = (props) => {
    const { content } = props;

    return (
        <div className={styles.grid}>
            {
                content && content[0] &&
                <div className={`${styles.gridItem} ${styles.large}`}>
                    <img src={formatImage(getThumbnail(content[0]), 300 * 2, 501 * 2)} alt="" />
                    <div className={styles.mask}>
                        <a href={content[0].url} target="_blank" rel="noreferrer">{content[0].title}</a>
                    </div>
                </div>
            }
            <div className={styles.right}>
                <div>
                    {
                        content.slice(1, 3).map((item, index) => {
                            return (
                                <div className={`${styles.gridItem} ${styles.small}`} key={index}>
                                    <img src={formatImage(getThumbnail(item), 300 * 2, 248 * 2)} alt="" />
                                    <div className={styles.mask}>
                                        <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div>
                    {
                        content.slice(3, 5).map((item, index) => {
                            return (
                                <div className={`${styles.gridItem} ${styles.small}`} key={index}>
                                    <img src={formatImage(getThumbnail(item), 300 * 2, 248 * 2)} alt="" />
                                    <div className={styles.mask}>
                                        <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

GridBox.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(GridBox);
